import EditCard from '@anm/components/credit-card/EditCard';
import { subscriptionModalSidePaddings } from '@anm/styles/helpers';
import styled from 'styled-components';

export const EditCardWrapper = styled(EditCard)`
  margin-bottom: 25px;
`;

export const EditCardFormRowItem = styled.div`
  margin: 10px;
  width: 253px;
`;

export const SubmitEditCardBlockWrapper = styled.div`
  margin-bottom: 25px;
  ${subscriptionModalSidePaddings};
`;
